import {
  Component,
  OnInit,
  Input,
  ViewChildren,
  QueryList,
  ElementRef,
  Renderer2,
  Inject,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Vehicle } from "../utility/utility-classes";
import { convertUtcToEst } from "../utility/time-conversion.util";
import { VehicleVersionReportService } from "../../services/vehicle-version-report.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VehicleVersionDTO } from "../../model/VehicleVersionDTO";

@Component({
    selector: "app-vehicle-version",
    templateUrl: "./vehicle-version.component.html",
    styleUrls: ["./vehicle-version.component.scss"],
    standalone: false
})
export class VehicleVersionComponent implements OnInit {
  @Input("vehicle") vehicle: Vehicle = null;
  control: UntypedFormControl = new UntypedFormControl("");
  loading = false;
  loaded = false;
  versions: VehicleVersionDTO[] = null;
  convertUtcToEst = convertUtcToEst;

  @ViewChildren("rows") rows: QueryList<ElementRef<HTMLTableRowElement>>;
  constructor(
    private vehicleVersionReportService: VehicleVersionReportService,
    private _renderer2: Renderer2,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit() {
    this.vehicle = this.data;
    this.setup();
  }

  setup() {
    this.vehicleVersionReportService
      .getVehicleVersionTieredMenuItems(parseInt(this.vehicle.id))
      .subscribe({
        next: (data: VehicleVersionDTO[]) => {
          this.versions = data;
        },
        complete: () => {
          this.colorizeCells();
          this.loaded = true;
          this.loading = false;
        },
      });
  }

  colorizeCells() {
    setTimeout(() => {
      for (let r = this.rows.length - 1; r > 0; r--) {
        for (let c = 0; c < this.rows.get(r).nativeElement.cells.length; c++) {
          if (
            this.rows.get(r).nativeElement.cells[c].innerHTML !==
              this.rows.get(r - 1).nativeElement.cells[c].innerHTML &&
            c != 0 &&
            this.rows.get(r).nativeElement.cells[1].innerHTML ==
              this.rows.get(r - 1).nativeElement.cells[1].innerHTML
          ) {
            this._renderer2.setStyle(
              this.rows.get(r - 1).nativeElement.cells[c],
              "backgroundColor",
              "#FFFF00"
            );
          }
        }
      }
    }, 10);
  }
}
